import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './relation-customer.reducer';

export const RelationCustomerDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const relationCustomerEntity = useAppSelector(state => state.relationCustomer.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="relationCustomerDetailsHeading">
          <Translate contentKey="crawlerBackendApp.relationCustomer.detail.title">RelationCustomer</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{relationCustomerEntity.id}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="crawlerBackendApp.relationCustomer.type">Type</Translate>
            </span>
          </dt>
          <dd>{relationCustomerEntity.type}</dd>
          <dt>
            <span id="title">
              <Translate contentKey="crawlerBackendApp.relationCustomer.title">Title</Translate>
            </span>
          </dt>
          <dd>{relationCustomerEntity.title}</dd>
          <dt>
            <span id="reportType">
              <Translate contentKey="crawlerBackendApp.relationCustomer.reportType">Report Type</Translate>
            </span>
          </dt>
          <dd>{relationCustomerEntity.reportType}</dd>
          <dt>
            <span id="incidentType">
              <Translate contentKey="crawlerBackendApp.relationCustomer.incidentType">Incident Type</Translate>
            </span>
          </dt>
          <dd>{relationCustomerEntity.incidentType}</dd>
          <dt>
            <span id="channel">
              <Translate contentKey="crawlerBackendApp.relationCustomer.channel">Channel</Translate>
            </span>
          </dt>
          <dd>{relationCustomerEntity.channel}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="crawlerBackendApp.relationCustomer.status">Status</Translate>
            </span>
          </dt>
          <dd>{relationCustomerEntity.status}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="crawlerBackendApp.relationCustomer.description">Description</Translate>
            </span>
          </dt>
          <dd>{relationCustomerEntity.description}</dd>
          <dt>
            <span id="updateDate">
              <Translate contentKey="crawlerBackendApp.relationCustomer.updateDate">Update Date</Translate>
            </span>
          </dt>
          <dd>
            {relationCustomerEntity.updateDate ? (
              <TextFormat value={relationCustomerEntity.updateDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="createDate">
              <Translate contentKey="crawlerBackendApp.relationCustomer.createDate">Create Date</Translate>
            </span>
          </dt>
          <dd>
            {relationCustomerEntity.createDate ? (
              <TextFormat value={relationCustomerEntity.createDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="contactRmsId">
              <Translate contentKey="crawlerBackendApp.relationCustomer.contactRmsId">Contact Rms Id</Translate>
            </span>
          </dt>
          <dd>{relationCustomerEntity.contactRmsId}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.relationCustomer.customer">Customer</Translate>
          </dt>
          <dd>{relationCustomerEntity.customer ? relationCustomerEntity.customer.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.relationCustomer.owner">Owner</Translate>
          </dt>
          <dd>{relationCustomerEntity.owner ? relationCustomerEntity.owner.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/relation-customer" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/relation-customer/${relationCustomerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RelationCustomerDetail;
